// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jN9i","colBig":"styles_colBig__2tP-4","colSmall":"styles_colSmall__1DGWt"};